import React from "react";
import css from "./Header.module.css";
import Logo from "../../imgs/logo.png";

const divStyle = {
  backgroundImage: "url(" + Logo + ")",
  width: "4rem",
  height: "4rem",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

const HeaderNew = () => {
  return (
    <div className={css.HeaderContent}>
      <div style={divStyle}></div>
      <div className={css.MainTitleContainer}>
              <h1 className={css.MainTitle}>Calcular Tarifa</h1>
            </div>
    </div>
  );
};

export default HeaderNew;
